/* eslint-disable */
import * as Yup from "yup";
import Validators from "../../../utils/validatorsHelper"

export const CadastrarEntidadeValidationSchema = Yup.object().shape({
    cnpj: Yup.string().trim()
        .test("cnpj", "CNPJ inválido", val => {
            if (val === undefined) {
                return false;
            }
            let valid = Validators.validarCNPJ(val);
            return valid;
        })
        .required("Campo obrigatório"),
    nome: Yup.string().trim().required("Campo obrigatório"),
    email: Yup.string().trim()
        .email("Informe um e-mail válido")
        .required("Campo obrigatório"),
    telefonePrincipal: Yup.string().trim()
        .test("telefonePrincipal", "Informe um telefone válido", val => {
            if (val === undefined) {
                return false;
            }
            let valid = Validators.validarTelefone(val);
            return valid;
        })
        .required("Campo obrigatório"),
    telefoneSecundario: Yup.string().trim().test(
        "telefoneSecundario",
        "Informe um telefone válido",
        val => {
            if (val === undefined) {
                return true;
            }
            let valid = Validators.validarTelefone(val);
            return valid;
        }
    ),
    endereco: Yup.object().shape({
        municipio: Yup.object().shape({
            codigoIbge: Yup.number()
                .min(1, "Campo obrigatório")
                .required("Campo obrigatório")
        }),
        cep: Yup.string().trim().required("Campo obrigatório"),
        bairro: Yup.string().trim().required("Campo obrigatório"),
        logradouro: Yup.string().trim().required("Campo obrigatório"),
        numero: Yup.string().trim().required("Campo obrigatório")
    })
})
